import React, {FC} from 'react'

export const WebAuthnIcon: FC = () => (
  <svg width="45" height="45" viewBox="0 0 45 45">
    <defs>
      <path
        id="xvz7dlr8ba"
        d="M0 14.178V4.485c4.621 0 8.832-1.698 12-4.485l.31.266c3.026 2.54 6.947 4.112 11.244 4.214l.446.005v9.693c0 7.13-4.925 12.841-11.667 14.732L12 29C5.088 27.206 0 21.426 0 14.178z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-520 -610) translate(50 170) translate(420 240) translate(50 200)">
        <circle
          cx="22.5"
          cy="22.5"
          r="22.5"
          fill="#424C65"
          fillRule="nonzero"
        />
        <g transform="translate(10 8)">
          <mask id="m5gxmxjhgb" fill="#fff">
            <use xlinkHref="#xvz7dlr8ba" />
          </mask>
          <use fill="#78A7FF" xlinkHref="#xvz7dlr8ba" />
          <circle
            cx="17.5"
            cy="4.5"
            r="17.5"
            fill="#EAF7FF"
            fillOpacity=".2"
            mask="url(#m5gxmxjhgb)"
          />
          <path
            fill="#5B88FE"
            d="M26 10c2.21 0 4 1.79 4 4v4c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1h-3v1.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V17h-1v1.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V17c-.552 0-1-.448-1-1s.448-1 1-1h8v-1c0-2.21 1.79-4 4-4zm0 2c-1.054 0-1.918.816-1.995 1.85L24 14v4c0 1.105.895 2 2 2 1.054 0 1.918-.816 1.995-1.85L28 18v-4c0-1.105-.895-2-2-2z"
            mask="url(#m5gxmxjhgb)"
          />
        </g>
        <path
          fill="#424C65"
          d="M22 20c1.105 0 2 .895 2 2 0 .754-.417 1.41-1.032 1.75.021.08.032.164.032.25v1c0 .552-.448 1-1 1s-1-.448-1-1v-1c0-.086.01-.17.031-.25C20.417 23.41 20 22.754 20 22c0-1.105.895-2 2-2z"
        />
        <path
          fill="#FFF"
          d="M36 16c2.21 0 4 1.79 4 4v4c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1h-3v1.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V23h-1v1.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V23c-.552 0-1-.448-1-1s.448-1 1-1h8v-1c0-2.21 1.79-4 4-4zm0 2c-1.054 0-1.918.816-1.995 1.85L34 20v4c0 1.105.895 2 2 2 1.054 0 1.918-.816 1.995-1.85L38 24v-4c0-1.105-.895-2-2-2z"
        />
      </g>
    </g>
  </svg>
)
